import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { EntityType } from '@planone/bau365/util-fair-data';
import { catchError, map, Observable, of } from 'rxjs';

import { ApiUserHistoryResult, GetUserHistoryApiResponse, PutUserHistoryResponse } from './history-response.models';

import { USER_SERVICE_CONFIG, UserServiceConfigInterface } from '../../config/user-service.config.interface';
import { UserHistoryEntry } from '../../state/history/history.models';

@Injectable()
export class UserHistoryService {
  constructor(
    @Inject(USER_SERVICE_CONFIG) private config: UserServiceConfigInterface,
    private httpClient: HttpClient
  ) {}

  getUserHistoryEntries(): Observable<UserHistoryEntry[]> {
    return this.httpClient.get<GetUserHistoryApiResponse>(`${this.config.userServiceApiURL}/user-history`).pipe(
      map((response) => response.items.map(this.mapUserHistoryResult)),
      catchError((error) => {
        if (error.status === 404) return of([]);
        throw error;
      })
    );
  }

  addToHistory(fairId: string, entityType: EntityType, id: string): Observable<UserHistoryEntry> {
    return this.httpClient
      .put<PutUserHistoryResponse>(`${this.config.userServiceApiURL}/user-history/${fairId}/${entityType}/${id}`, {})
      .pipe(map(this.mapUserHistoryResult));
  }

  private mapUserHistoryResult(result: ApiUserHistoryResult): UserHistoryEntry {
    return {
      id: result.entity_id,
      entityType: result.entity_type,
      fairId: result.fair_id,
      createdAt: new Date(result.created_at),
    };
  }
}
